import { DateFormat, formatDate } from "common";
import React from "react";
import { useAirbnbMessagingPlugin } from "../../hooks/usePlugins";
import { MessageDrawer } from "../Common/MessageModal/MessageDrawer";

interface MessageEventModalProps {
    date: string;
    eventIds?: ID[];
    onClose: () => void;
    isOpen: boolean;
}

export const MessageDayEventsModal = ({ date, eventIds = [], onClose, isOpen }: MessageEventModalProps) => {
    const airbnbPlugin = useAirbnbMessagingPlugin();
    const filters = {
        date,
        ...(eventIds?.length > 0 && { events: eventIds }),
    };

    const dateLabel = date ? formatDate(date, DateFormat.DATE_LONG) : "N/A";
    const scopeSuffix = eventIds.length > 0 ? " for selected experiences" : "";
    const description = (
        <>
            This message will be sent to all guests on <var data-var="date">{dateLabel}</var>
            {scopeSuffix}.
        </>
    );

    return (
        <MessageDrawer
            title="Send Group Message"
            filters={filters}
            isOpen={isOpen}
            description={description}
            channels={{ messagingPlugin: airbnbPlugin ?? undefined }}
            onClose={onClose}
        />
    );
};
